import { ParameterType } from '@/study-search/enums';

import { DurationFilterOptionValue } from '@studyportals/search-filters/server-side';
import { FilterDefinition } from '../FilterDefinition';
import { FilterOptionInformation } from '@studyportals/search-filters';

class ShortCoursesDurationFilterDefinition extends FilterDefinition {
	public constructor() {
		super(
			ParameterType.DURATION,
			[
				new FilterOptionInformation('Less than 1 month', DurationFilterOptionValue.LESS_THAN_ONE_MONTH, 'short', 'Short term'),
				new FilterOptionInformation('1-3 months', DurationFilterOptionValue.ONE_TO_THREE_MONTHS, '', ''),
				new FilterOptionInformation('More than 3 months', DurationFilterOptionValue.MORE_THAN_THREE_MONTHS, '', ''),
			],
			[DurationFilterOptionValue.LESS_THAN_ONE_MONTH],
		);
	}
}

export default new ShortCoursesDurationFilterDefinition();
